import { SocialProfile } from '@/types/profile.type';

import { reviewPlatforms } from './review-platforms.config';
import { socialProfiles } from './social-profiles.config';

export const socialIconLinks: SocialProfile[] = [
  ...socialProfiles,
  ...reviewPlatforms.flatMap(({ name, profileUrl, socialIcon }) =>
    socialIcon ? [{ name, href: profileUrl, icon: socialIcon }] : []
  ),
];

export const verifiedLinkPlatforms = reviewPlatforms.filter(platform => platform.verifiedLink);

// Schema.org sameAs: every profile we own, whether or not it is shown on the site
export const sameAsUrls = [
  ...socialProfiles.map(profile => profile.href),
  ...reviewPlatforms.map(platform => platform.profileUrl),
];
